import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/%E7%94%B5%E5%BD%B1" },
  { label: "电视剧", to: "/category/%E7%94%B5%E8%A7%86%E5%89%A7" },
  { label: "短片", to: "/category/%E7%9F%AD%E7%89%87" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    navigate(`/search?q=${encodeURIComponent(kw)}`);
    setKeyword("");
  };

  const isActive = (to: string) =>
    decodeURIComponent(location.pathname) === decodeURIComponent(to);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 border-b border-background-200"
          : "bg-gradient-to-b from-background-50/90 to-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-leaf-fill text-xl md:text-2xl"></i>
            </span>
            <span className="text-xl md:text-2xl font-heading tracking-wide text-foreground-950">
              嫩草视频
            </span>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-1 lg:gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 text-sm rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                  isActive(link.to)
                    ? "text-primary-500 bg-primary-500/10"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-200"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Right side */}
          <div className="flex items-center gap-3">
            <form onSubmit={handleSearch} className="hidden sm:flex items-center">
              <div className="flex items-center bg-background-200 rounded-full px-3 h-10 w-44 lg:w-60">
                <i className="ri-search-line text-foreground-600 text-base"></i>
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索影视内容"
                  className="bg-transparent border-none outline-none text-sm text-foreground-950 placeholder:text-foreground-600 px-2 w-full"
                />
              </div>
            </form>

            <Link
              to="/search"
              className="sm:hidden w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-800 cursor-pointer"
            >
              <i className="ri-search-line text-lg"></i>
            </Link>

            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开菜单"
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-800 cursor-pointer"
            >
              <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 ng-animate-in">
          <div className="px-4 py-4 flex flex-col gap-2">
            <form onSubmit={handleSearch} className="flex items-center bg-background-200 rounded-full px-3 h-11 mb-2">
              <i className="ri-search-line text-foreground-600 text-base"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视内容"
                className="bg-transparent border-none outline-none text-sm text-foreground-950 placeholder:text-foreground-600 px-2 w-full"
              />
            </form>
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 rounded-lg text-base cursor-pointer ${
                  isActive(link.to)
                    ? "text-primary-500 bg-primary-500/10"
                    : "text-foreground-800 hover:bg-background-200"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-3 rounded-lg text-base text-foreground-800 hover:bg-background-200 cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}